import { Injectable } from '@angular/core';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { TabObject } from '../../components/tabs/tabs.model';
import { IRoute } from '../../models/iroute.interface';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
/**
 * Builds transaction routes for IRP
 */
export class IRPRouteBuilderService extends RouteBuilderService {

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.IRP;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    getRouteList(businessTransactionTypeId: number): any[] {
        const routeList: IRoute[] = [];

        switch (businessTransactionTypeId) {
            case 1149: {
                return this.getMotorCarrierAddVehicleRoutes();
            }
            case 1143: {
                return this.getMotorCarrierChangeNameRoutes();
            }
            case 1144: {
                return this.getMotorCarrierStraightRenewalRoutes();
            }
            case 1145: {
                return this.getMotorCarrierCreateIFTARoutes();
            }
            case 1148: {
                return this.getMotorCarrierDeleteVehicleRoutes();
            }
            case 1150: {
                return this.getMotorCarrierRenewalRoutes();
            }
            case 1151: {
                return this.getMotorCarrierAddVehicleTransferRoutes();
            }
            case 1152: {
                return this.getMotorCarrierReplacePlateRoutes();
            }
            case 1153: {
                return this.getMotorCarrierCabCardCorrectionRoutes();
            }
            case 1154: {
                return this.getMotorCarrierAmendVehicleRoutes();
            }
            case 1157: {
                return this.getMotorCarrierReplaceCabCardRoutes();
            }
            case 1159: {
                return this.getMotorCarrierAccountIFTAQuarterlyFuelTaxRoutes();
            }
            case 1160: {
                return this.getMotorCarrierAccountIFTAAddDecalsRoutes();
            }
            case 1165: {
                return this.getMotorCarrierAccountIFTAReplaceDecalsRoutes();
            }
            case 1162: {
                return this.getMotorCarrierAccountIFTADuplicateLicenseRoutes();
            }
            case 1163: {
                return this.getMotorCarrierRenewIFTARoutes();
            }
            case 1166: {
                return this.getMotorCarrierErrorCorrectionMileageRoutes();
            }
            case 1191: {
                return this.getMotorCarrierErrorCorrectionVehicleRoutes();
            }
            case 1167: {
                return this.getMotorCarrierErrorCorrectionDeleteVehicleRoutes();
            }
            case 1175: {
                return this.getMotorCarrierTPARoutes();
            }
            case 1176: {
                return this.getMotorCarrierIFTAAddBondRoutes();
            }
            case 1177: {
                return this.getMotorCarrierIFTAUpdateBondRoutes();
            }
            case 1190: {
                return this.getMotorCarrierVehicleMaintenanceRoutes();
            }
            case 1181: {
                return this.getMotorCarrierAccountIRPAuditRoutes();
            }
            case 1195: {
                return this.getMotorCarrierAccountIFTAMaintainLicense();
            }
            default: {
                throw new Error('The business transaction type does not have its route list configured in the (area)-route-builder service');
            }
        }

        return routeList;
    }

    private getMotorCarrierChangeNameRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-change-name', title: 'Motor Carrier', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAddVehicleRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-add-vehicle', title: 'Motor Carrier', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-add-vehicle-service-types', title: 'Service Types', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierStraightRenewalRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-straight-renewal', title: 'Motor Carrier Renewal', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierCreateIFTARoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-create-ifta', title: 'Motor Carrier - Create IFTA', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAccountIFTAAddDecalsRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-add-decals', title: 'Motor Carrier - IFTA Add Decals', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAccountIFTAReplaceDecalsRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-replace-decals', title: 'Motor Carrier - IFTA Replace Decals', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAccountIFTADuplicateLicenseRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-duplicate-license', title: 'Motor Carrier - IFTA Duplicate License', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAccountIFTAQuarterlyFuelTaxRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-quarterly-fuel-tax', title: 'Motor Carrier - IFTA Quarterly Fuel Tax Report', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierRenewIFTARoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-renew-ifta', title: 'Motor Carrier - Renew IFTA', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierDeleteVehicleRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-delete-vehicle', title: 'Motor Carrier - Delete Vehicle', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierCabCardCorrectionRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-cab-card-correction', title: 'Motor Carrier - Cab Card Correction', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-cab-card-correction-service-types', title: 'Vehicle Details', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierReplaceCabCardRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-replace-cab-card', title: 'Motor Carrier - Replace Cab Card', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAmendVehicleRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-amend-vehicle', title: 'Motor Carrier - Amend Vehicle', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-amend-vehicle-service-types', title: 'Vehicle Details', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierErrorCorrectionMileageRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-error-correction-mileage', title: 'Motor Carrier - Error Correction- Mileage', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierErrorCorrectionVehicleRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-error-correction-vehicle', title: 'Motor Carrier Vehicle Correction', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-error-correction-vehicle-service-types', title: 'Vehicle Details', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false},
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierErrorCorrectionDeleteVehicleRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-error-correction-delete-vehicle', title: 'Motor Carrier - Error Correction- Delete-Vehicle', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierRenewalRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-renewal', title: 'Motor Carrier Renewal', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'renewal-vehicle-lists', title: 'Vehicles', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-add-vehicle-service-types', title: 'Add Vehicle', isActive: false, isHidden: true, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-amend-vehicle-service-types', title: 'Amend Vehicle', isActive: false, isHidden: true, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierTPARoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-tpa', title: 'TPA', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }
    private getMotorCarrierReplacePlateRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-replace-plate', title: 'Motor Carrier - Replace Plate', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierIFTAAddBondRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-add-bond', title: 'Motor Carrier - IFTA Add Bond', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierIFTAUpdateBondRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-update-bond', title: 'Motor Carrier - IFTA Update Bond', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAddVehicleTransferRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-add-vehicle-transfer', title: 'Motor Carrier- Add Vehicle Transfer', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'motor-carrier-account-add-vehicle-service-types', title: 'Service Types', isActive: false, isHidden: true, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierVehicleMaintenanceRoutes(): TabObject[] {
        return [
            { name: 'vehicle-maintenance-title', title: 'Vehicle', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'vehicle-maintenance-owners', title: 'Owners', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false },
            { name: 'documents', title: 'Documents', isActive: false, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAccountIRPAuditRoutes(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-quarterly-fuel-tax', title: 'IRP Audit', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }

    private getMotorCarrierAccountIFTAMaintainLicense(): TabObject[] {
        return [
            { name: 'motor-carrier-account-ifta-maintain-license', title: 'Maintain IFTA License', isActive: true, isHidden: false, route: null, hasTooltip: false, hasValidation: false }
        ];
    }
}
